import StockOpname from '@/models/StockOpname/StockOpname';

export default class StockOpnameFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.stockOpnamePlanId  = '';
		this.stockOpnamePlanName = '';
		this.areaStoId  = '';
		this.areaStoCode = '';
		this.vendorSubconId  = '';
		this.vendorSubconCode = '';
		this.idCard = '';
		this.totalCaseArea = '';
		this.totalCaseActual = '';
		this.stockOpnameStatusId  = '';
		this.stockOpnameStatusName = '';
		this.stockOpnameLabelCombo = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			stockOpnamePlanId : '0',
			stockOpnamePlanName : '0',
			areaStoId : '0',
			areaStoCode : '0',
			vendorSubconId : '0',
			vendorSubconCode : '0',
			idCard : '0',
			totalCaseArea : '0',
			totalCaseActual : '0',
			stockOpnameStatusId : '0',
			stockOpnameStatusName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}